import type { ILookersParams } from '~/types/lookers'

import config from '~/config'
import { request } from '~/utils/request'

export const getLookersFilters = <T = any>(appKey: string, deviceType: string, params: ILookersParams): Promise<T> => {
  return request({
    data: {
      app_key: appKey,
      device_type: deviceType,
      filters: params.filters.map((filter) => ({
        condition_type: 'in',
        key: filter.key,
        values: filter.value,
      })),
    },
    method: 'POST',
    url: `${config.ANALYTICS_API}/graph-data/filters`,
  })
}
